import { AppBar, Box, Container, Toolbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { colorPublicMenuBg, colorPublicMenuText } from "src/design/tokens";

// Minimal public header: only the centered "L'addition" logo, no nav or CTAs.
// A deliberately separate component from LandingHeader — do not add logic there.
export const PublicPageHeader = () => {
  const navigate = useNavigate();

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: colorPublicMenuBg,
        borderBottom: `1px solid ${colorPublicMenuText}14`,
        zIndex: 1200,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar
          disableGutters
          sx={{ height: 64, justifyContent: "center" }}
        >
          <Box
            onClick={() => navigate("/")}
            sx={{
              fontFamily: "Bogart-bold",
              fontSize: 22,
              fontWeight: 700,
              color: colorPublicMenuText,
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            L'addition
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
